interface Messages {
  errors: {
    noToken: string;
    noStoreClerkId: string;
    fetchFailed: string;
    notRegistered: string;
    storeLocked: string;
  };
  success: {
    loginSuccess: string;
  };
}

const messages: Messages = {
  errors: {
    noToken: "認証トークンが見つかりません。ログインしてください。",
    noStoreClerkId: "storeClerkIdがURLに指定されていません",
    fetchFailed: "データの取得中にエラーが発生しました",
    notRegistered: "このアカウントは店舗に登録されていません。店舗の管理者に招待を依頼してください。",
    storeLocked: "この店舗は削除リクエスト中のため利用できません。運営による解除までお待ちください。",
  },
  success: {
    loginSuccess: "ログインに成功しました！",
  },
};

export default messages;